import "./Toggle.scss";

const Toggle = ({ state, handleClick }) => {
  return (
    <div className="toggle">
      <div className="toggle-wrapper">
        <div onClick={handleClick} className="toggleSwitch">
          <div className={state.isOnShore ? "knob active" : "knob"} />

          <div className="toggle-text"></div>
          {state.isOnShore ? (
            <span className="paragraph-gray-bold-16">Onshore</span>
          ) : (
            <span className="paragraph-gray-bold-16">Offshore</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Toggle;
